jQuery(function($){
	$(document).ready(function(e){
		const checkMenuLoaded = setInterval(function(){
			if( $('.image-banner-menu').length > 0 ) {
				clearInterval(checkMenuLoaded);
				$('.image-banner-menu').each(function(e) {
					$(this).find("img").wrap( "<div class='img-wrap'></div>" )
				});
			}
		}, 100);

        const checkYotpoRewardOpened = setInterval(function(){
			if( $('#yotpo-drawer-layout').css('display') == 'block' ) {
				$('.yotpo-widget-loyalty-floater-widget').addClass('YotpoRewardOpened');
			} else {
              $('.yotpo-widget-loyalty-floater-widget').removeClass('YotpoRewardOpened');
            }
		}, 100);
		
		const checkMenuTitleLoaded = setInterval(function(){
			if( $('.gm-item a[title]').length > 0 ) {
				clearInterval(checkMenuTitleLoaded);
				$(".gm-item a[title]").each(function(e) {
					var thisTitle = $(this).attr('title');
					$(this).attr('aria-label',thisTitle);
					$(this).removeAttr("title");
				});
              
			}
		}, 100);

      $('.mobile-trigger-sort').click(function(){
          $(this).toggleClass("opened");
      })
       $('a.popup-img').click(function(e){
          e.preventDefault();
          var clickedUrl = $(this).attr('href');
          // Simulate a mouse click:
          $(this).closest('.popup-content').find('a.popup-close').addClass('clicked');
          document.querySelector('a.popup-close.clicked').dispatchEvent(new Event('click'));
          window.location.href = clickedUrl;
      })

      $(document).on('click', '.random_trigger_img', function(e){
          e.preventDefault();
          var popupID = $(this).attr('data-popup-id');
          // Simulate a mouse click:
          if( $('.'+popupID).hasClass('random-popup-modal-hidden') ) {
            $('.'+popupID).removeClass("random-popup-modal-hidden");
          } else {
            $('.'+popupID).addClass("visible");
          }
      })
      $(document).on('click', '.random-popup-modal .popup-outer', function(e){
        $('.random-popup-modal').removeClass("visible");
       })
      $(document).on('click', '.random-popup-modal .popup-inner:not(.popup-content)', function(e){
        $('.random-popup-modal').removeClass("visible");
      })
      /*
      $(".page-frame-section").load('https://sukin.searchbrown.com/earth/', function( response, status, xhr ) {
        $(".page-frame-section").append(response);
      });*/

      $(".pageIframes").each(function(){
			  $('#'+$(this).attr('id')).on('load', function () {
          $('.iframe-loading-img').fadeOut('slow');
        });
			  iFrameResize({ log: false, autoResize:true, inPageLinks: true }, '#'+$(this).attr('id'))
		  })

      let options = {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        timeZone: 'Australia/Sydney'
      };
      var dateToday = new Date().toLocaleString('en', options);
      const dateCurrentTime = new Date(dateToday);
      const datecurrentHour = dateCurrentTime.getHours();
      const datecurrentMinutes = dateCurrentTime.getMinutes();
      const dayOfWeekIndex = dateCurrentTime.getDay();
      const timestamp = dateCurrentTime.getTime();
      const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
      const dayName = days[dayOfWeekIndex];
      
      
      if( $('.schedule-popup').length > 0 ) {
        $('.schedule-popup').each(function(){
          let scheduled_days = $(this).attr('data-s-days');
          let scheduled_shour = parseInt( $(this).attr('data-s-shour') );
          let scheduled_smin = parseInt( $(this).attr('data-s-smin') );
          let scheduled_sampm = $(this).attr('data-s-sampm');
          let scheduled_ehour = parseInt( $(this).attr('data-s-ehour') );
          let scheduled_emin = parseInt( $(this).attr('data-s-emin') );
          let scheduled_eampm = $(this).attr('data-s-eampm');
          let scheduled_days_array = scheduled_days.split(',');
          
          if ( scheduled_sampm == "PM" && scheduled_shour < 12 ) {
            scheduled_shour += 12;
          } else if ( scheduled_sampm == "AM" && scheduled_shour === 12 ) {
            scheduled_shour = scheduled_shour;
          }
          if ( scheduled_eampm == "PM" && scheduled_ehour < 12 ) {
            scheduled_ehour += 12;
          } else if ( scheduled_sampm == "AM" && scheduled_ehour === 12 ) {
            scheduled_ehour = scheduled_ehour;
          }

          var dateSchedule = new Date().toLocaleString('en', options);
          const dateScheduleSTime = new Date(dateSchedule);
          const dateScheduleETime = new Date(dateSchedule);

          dateScheduleSTime.setHours(scheduled_shour, scheduled_smin, 0, 0);
          var timestampMSs = dateScheduleSTime.getTime();

          dateScheduleETime.setHours(scheduled_ehour, scheduled_emin, 0, 0);
          var timestampMEs = dateScheduleETime.getTime(); 

          console.log(timestampMSs);
          console.log(timestampMEs);

          if ($.inArray(dayName, scheduled_days_array ) !== -1) {
            if( timestampMSs <= timestamp && timestampMEs >= timestamp ) {
              console.log("Value exists in array!");
              $(this).removeClass('hidden-visible');
            } else {
              console.log("Value not exists in array!");
              $(this).addClass('hidden-visible');
              $(this).removeClass('visible');
              if( $('.popup.visible').length < 1 ) {
                //$('body').removeClass('active-popup');
              }
            }
          } else {
            console.log("Value not exists in array 1!");
            $(this).addClass('hidden-visible');
            $(this).removeClass('visible');
            if( $('.popup.visible').length < 1 ) {
              //$('body').removeClass('active-popup');
            }
          }
          console.log(scheduled_days);
        })
      }
      
      /*console.log(dayName);
      console.log(datecurrentHour);
      console.log(datecurrentMinutes);
      console.log(timestamp);*/

      document.querySelectorAll('.add-to-bag').forEach((btn) => {
      btn.addEventListener('click', () => {
        btn.classList.add('adding-to-cart-button');
      });
    });

    document.addEventListener("cart:sending", (event) => {
      document.querySelectorAll('.add-to-bag.adding-to-cart-button').forEach((btn) => {
        console.log(`cart:sending`);
        const spinner = btn.querySelector('.spinner');
        spinner.hidden = false;          // show spinner next to text
      });
    });

    document.addEventListener('cart:itemAdded', () => {
      document.querySelectorAll('.add-to-bag').forEach((btn) => {
        btn.querySelector('.spinner').hidden = true;
        btn.classList.remove('adding-to-cart-button');
      });
    });

    document.addEventListener('cart:updated', () => {
      console.log('cart:updated');
      updateCartDiscountDOM();
    });

    function updateCartDiscountDOM() {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const totalDiscountCents = cart.total_discount;
          
          // 1. Locate the main wrapper element
          const discountWrapper = document.getElementById('cart-total-discounts-container');
          const discountValueSpan = discountWrapper ? discountWrapper.querySelector('.cart-total-discount-price') : null;

          if (discountWrapper && discountValueSpan) {
            // 2. Hide the div completely if the discount is 0
            if (totalDiscountCents === 0) {
              console.log('0');
              discountWrapper.style.display = 'none';
            } else {
              console.log('more than 0');
              // 3. Show the div and update the text if a discount exists
              const decimalDiscount = (totalDiscountCents / 100).toFixed(2);
              discountValueSpan.textContent = `$${decimalDiscount}`;
              discountWrapper.style.display = 'block'; // or 'flex' depending on your CSS
            }
          }
        })
        .catch(error => console.error('Error fetching Shopify cart:', error));
    }


  })

})


document.addEventListener('DOMContentLoaded', () => {
  const buyNowButton = document.querySelector('.collection-product .custom-buy-now-btn');

  if (buyNowButton) {
    buyNowButton.addEventListener('click', (e) => {
      const productName = e.currentTarget.getAttribute('data-productname');
      console.log('buyNowButton');
      gtag('event', 'buy_now_click', {
        product_name: productName,
        placement:'collection_grid',
      });
    });
  } else {
    console.warn('buyNowButton Element not found!');
  }
});


function getCookie(name) {
    let cookieArr = document.cookie.split(";");
    for (let i = 0; i < cookieArr.length; i++) {
        let cookiePair = cookieArr[i].split("=");
        // Trims the name and checks if it matches
        if (name === cookiePair[0].trim()) {
            return decodeURIComponent(cookiePair[1]);
        }
    }
    return null;
}

function setCookie(name, value, daysToLive) {
    let cookieString = `${name}=${encodeURIComponent(value)}; path=/; SameSite=Lax`;
    if (daysToLive) {
        let date = new Date();
        date.setTime(date.getTime() + (daysToLive * 24 * 60 * 60 * 1000));
        cookieString += `; expires=${date.toUTCString()}`;
    }
    document.cookie = cookieString;
}

function initDiscountObserver() {
    const discountElement = document.querySelector('.cart-total-discount-price');

    if (discountElement) {
        console.log(`discountElement found! Starting observer...`);

        const observerCallback = (entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    console.log("Element has scrolled into view!");

                    const discountText = discountElement.textContent || discountElement.innerText;
                    const discountValue = parseFloat(discountText.replace(/[^0-9.]/g, '')) || 0;
                    console.log(`discountValue found! Value: ${discountValue}`);

                    if (discountValue > 0) {
                        let cookieName = "user_saved_box_session";
                        let myCookie = getCookie(cookieName);

                        // Convert existing cookie value to a float for clean comparison
                        let currentCookieValue = myCookie ? parseFloat(myCookie) : null;

                        // Trigger if cookie doesn't exist OR if the value has changed
                        if (currentCookieValue === null || currentCookieValue !== discountValue) {
                            
                            let isFirstTime = (currentCookieValue === null);
                            console.log(isFirstTime ? "Cookie is 1st time!" : "Cookie value changed!");

                            // 1. Save the actual discountValue to the cookie
                            setCookie(cookieName, discountValue.toString(), 7);
                            console.log(`Cookie set/updated to: ${discountValue}`);

                            // 2. Trigger the gtag event
                            if (typeof gtag === 'function') {
                                gtag('event', 'savings_box_view', {
                                    'placement':    'cart_drawer',
                                    'saved_amount': discountValue,
                                });
                                console.log("gtag event sent successfully.");
                            } else {
                                console.warn("gtag is not defined on this page. Make sure Google Analytics is loaded.");
                            }
                        } else {
                            console.log("Cookie exists and value matches. No action taken.");
                        }

                        // Stop watching since we already processed this scroll event
                        observer.unobserve(discountElement);
                    }
                }
            });
        };

        const observer = new IntersectionObserver(observerCallback, { threshold: 0.1 });
        observer.observe(discountElement);
    } else {
        console.log(`discountElement not found yet. Retrying in 1 second...`);
        setTimeout(initDiscountObserver, 1000);
    }
}

if (window.location.pathname.includes('/cart')) {
    console.log("URL matches /cart. Initializing discount observer...");
    initDiscountObserver();
} else {
    console.log("Not on a /cart page. Script tracking skipped.");
}



// Event Delegation: Listen to all clicks on the document
document.addEventListener('click', function(event) {
    // 1. Check if the clicked element (or its inner span) is the "ADD" button
    const btn = event.target.closest('.qsc2-r-product__actions .qsc2-btn');
    
    if (btn) {
      console.log(`"ADD" clicked for: ${productName} (ID: ${productId}, Price: ${priceValue})`);
        // 2. Find the main parent container for this specific product card
        const productCard = btn.closest('.qsc2-r-product');
        
        if (productCard) {
            // 3. Extract the product name from the title element inside this card
            const titleElement = productCard.querySelector('.qsc2-r-product__product-title span');
            const productName = titleElement ? titleElement.textContent.trim() : 'Unknown Product';
            
            // 4. Extract Shopify IDs directly from the button attributes (Optional but highly useful for GA4)
            const productId = btn.getAttribute('product-id') || '';
            const variantId = btn.getAttribute('variant-id') || '';
            
            // 5. Extract the price if available
            const priceElement = productCard.querySelector('.qsc2-r-product__price .money');
            const priceValue = priceElement ? parseFloat(priceElement.textContent.replace(/[^0-9.]/g, '')) : 0;

            console.log(`"ADD" clicked for: ${productName} (ID: ${productId}, Price: ${priceValue})`);

            // 6. Trigger the gtag event
            if (typeof gtag === 'function') {
                gtag('event', 'add_to_cart', {
                    product_name: productName,
                    placement: 'cart_drawer'
                });
                console.log("gtag add_to_cart event sent successfully.");
            } else {
                console.warn("gtag is not defined on this page.");
            }
        }
    }
});
